import React from 'react';
import './ErrorBox.css';
const ErrorBox = (props) => {
    return <div className="error-box">
        <span class="error-icon"></span>
        <span> {props.children}</span>
    </div>
}

export default ErrorBox;